/* Performance Reel progressive accordion for H3 product descriptions.
 * Do not hide source HTML until all destination panels have been generated.
 */
(function () {
  'use strict';
  function convert(root) {
    if (!root || root.dataset.prh3Ready === 'true') return;
    var source = root.querySelector('.prh3__source');
    var intro = root.querySelector('.prh3__intro');
    var list = root.querySelector('.prh3__items');
    if (!source || !intro || !list) return;
    var heads = Array.from(source.querySelectorAll('h3')).filter(function (h) { return Boolean(h.textContent.trim()); });
    try {
      var between = function (a, b) {
        var range = document.createRange();
        if (a) range.setStartAfter(a); else range.setStart(source, 0);
        if (b) range.setEndBefore(b); else range.setEnd(source, source.childNodes.length);
        return range.cloneContents();
      };

      // H3 sections are generated automatically. Content before the first H3
      // becomes an expanded Information panel. Products without any H3 still
      // receive an expanded Information panel for their entire description.
      var leading = heads.length ? between(null, heads[0]) : source.cloneNode(true);
      var visibleCheck = leading.cloneNode(true);
      visibleCheck.querySelectorAll('style,script,noscript,template,meta,link').forEach(function (node) {
        node.remove();
      });
      var hasInfo = Boolean(
        visibleCheck.textContent.trim() ||
        visibleCheck.querySelector('img,iframe,video,table,ul,ol,svg,object,embed')
      );
      if (!hasInfo && !heads.length) return; // Empty descriptions remain visible.

      var fragment = document.createDocumentFragment();
      function createPanel(title, contents, expanded) {
        var item = document.createElement('details');
        item.className = 'prh3__item';
        if (expanded) item.open = true;
        var summary = document.createElement('summary');
        summary.textContent = title;
        var content = document.createElement('div');
        content.className = 'prh3__content';
        content.appendChild(contents);
        item.appendChild(summary);
        item.appendChild(content);
        fragment.appendChild(item);
      }

      if (hasInfo) {
        var firstHeading = heads.length ? heads[0].textContent.trim().toLowerCase() : '';
        createPanel(firstHeading === 'information' ? 'Overview' : 'Information', leading, true);
      } else if (heads.length) {
        // Preserve any leading styles or other nonvisible markup without
        // generating an empty Information accordion.
        intro.replaceChildren(leading);
        intro.hidden = false;
      }
      heads.forEach(function (head, index) {
        createPanel(head.textContent.trim(), between(head, heads[index + 1] || null), false);
      });
      if (fragment.childNodes.length !== heads.length + (hasInfo ? 1 : 0)) return;

      list.replaceChildren(fragment);
      if (hasInfo) { intro.replaceChildren(); intro.hidden = true; }
      list.hidden = false;
      source.hidden = true;
      root.dataset.prh3Ready = 'true';
    } catch (err) {
      source.hidden = false;
      list.hidden = true;
      if (typeof console !== 'undefined' && console.warn) console.warn('PR H3 accordion fallback:', err);
    }
  }
  function init(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('.prh3').forEach(convert);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function () { init(document); });
})();
